import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';
import { BadgeService, IEnrichedBadge } from '../../services/badge.service';

@Component({
  selector: 'shared-home-staffer-badges',
  templateUrl: './home-staffer-badges.component.html',
  styleUrls: ['./home-staffer-badges.component.scss'],
})
export class HomeStafferBadgesComponent implements OnInit, OnChanges {
  @Input() userData: IUser;
  @Input() horizontalOnly?= false;
  @Input() isDirectHire?= false;
  enrichedBadges: IEnrichedBadge[] = [];

  constructor(private badgeService: BadgeService) { }

  ngOnInit() {
    this.loadBadges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userData) {
      this.loadBadges();
    }
  }

  private loadBadges() {
    if (!this.userData) return;

    if (this.userData.computedBadges && this.userData.computedBadges.length > 0) {
      this.enrichedBadges = this.badgeService.getBadgesForView(
        this.userData.computedBadges,
      );
    } else {
      this.enrichedBadges = [];
    }
  }

  getBadgeIcon(badgeKey: string): string {
    return this.badgeService.getBadgeIcon(badgeKey);
  }

  getBadgeImage(badgeKey: string): string | null {
    return this.badgeService.getBadgeImagePath(badgeKey);
  }
}
